import { useQuery } from "@tanstack/react-query";
import { fetchGETRequest } from "../utils/services";

export interface MeterDeviceEvent {
  ID: string;
  CreatedAt: string;
  MeterID: string;
  Command: string;
  Code: string;
  Type: string;
  category?: string;
  status?: string;
  severity?: string;
  suggestedAction?: string;
}

const fetchMeterDeviceEvents = async (
  meterId: string
): Promise<MeterDeviceEvent[]> => {
  if (!meterId) return [];

  const response = await fetchGETRequest<{ data: MeterDeviceEvent[] }>(
    `devices/${meterId}/events`
  );
  return response?.data || [];
};

const useMeterDeviceEvents = (meterId: string) => {
  return useQuery({
    queryKey: ["meterDeviceEvents", meterId],
    queryFn: () => fetchMeterDeviceEvents(meterId),
    enabled: !!meterId,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

export default useMeterDeviceEvents;
